<template>
  <div class="job-page">
    <!-- 筛选栏 -->
    <div class="select-row">
      <div class="select-box">
        <el-select v-model="selectedSecond" placeholder="请选择企业" clearable>
          <el-option label="全部企业" value="" />
          <el-option
            v-for="item in secondOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>

      <div class="select-box">
        <el-select v-model="name" placeholder="请选择岗位" clearable>
          <el-option label="全部岗位" value="" />
          <el-option
            v-for="item in jobOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>

    <!-- 岗位列表：卡片点击跳转，详情合并折叠 -->
    <div class="job-list">
      <div
        class="job-item"
        v-for="job in filteredJobs"
        :key="job.id"
        @click="goLink(job.url)"
      >
        <div class="job-header">
          <!-- 左侧：岗位+企业 -->
          <div class="job-left">
            <div class="job-name">{{ job.name }}</div>
            <div class="job-company">
              {{ job.secondCompany }}
              <span v-if="job.third"> - {{ job.third }}</span>
            </div>
          </div>
          <!-- 右侧：报名按钮 -->
          <el-button
            class="apply-btn"
            type="primary"
            size="mini"
            icon="el-icon-user-add"
            @click.stop="goLink(job.url)"
          >
            报名入口
          </el-button>
        </div>

        <div class="job-info">
          <span class="info-item">📍 {{ job.location }}</span>
          <span class="info-item">📚 {{ job.education }}</span>
          <span class="info-item">👥 需求{{ job.needNum }}人</span>
          <span class="info-item">🏅 {{ job.jobType }}</span>
        </div>

        <!-- 合并：岗位职责 + 任职资格 + 薪酬，一起折叠 -->
        <div class="desc-block" @click.stop="toggleDetail(job.id)">
          <div class="desc-title">
            查看详情
            <i class="arrow" :class="{ open: openIds.includes(job.id) }"></i>
          </div>
          <div class="desc-content" v-show="openIds.includes(job.id)">
            <div class="sub-title">岗位职责：</div>
            {{ job.desc }}
            <div class="sub-title" style="margin-top: 8px">任职资格：</div>
            {{ job.requirement }}
          </div>
        </div>
      </div>

      <div class="empty" v-if="filteredJobs.length === 0">
        暂无匹配的招聘岗位
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabJob",
  data() {
    return {
      selectedSecond: "",
      selectedLocation: "",
      name: "",
      selectedEdu: "",
      openIds: [],
      secondOptions: [
        {
          label: "深圳万润科技股份有限公司",
          value: "深圳万润科技股份有限公司",
        },
        {
          label: "湖北长江北斗数字产业有限公司",
          value: "湖北长江北斗数字产业有限公司",
        },
        {
          label: "湖北省长江新动能私募基金管理有限公司",
          value: "湖北省长江新动能私募基金管理有限公司",
        },
        {
          label: "湖北长江产业现代化工有限公司",
          value: "湖北长江产业现代化工有限公司",
        },
        {
          label: "湖北省长江新材有限公司",
          value: "湖北省长江新材有限公司",
        },
        {
          label: "湖北省生态环保有限公司",
          value: "湖北省生态环保有限公司",
        },
        {
          label: "湖北省新能源有限公司",
          value: "湖北省新能源有限公司",
        },
        {
          label: "湖北长江产业载体投资开发有限公司",
          value: "湖北长江产业载体投资开发有限公司",
        },
        {
          label: "湖北省人才发展集团有限公司",
          value: "湖北省人才发展集团有限公司",
        },
        {
          label: "湖北长江产融资本投资有限公司",
          value: "湖北长江产融资本投资有限公司",
        },
        {
          label: "湖北长江汽车产业投资有限公司",
          value: "湖北长江汽车产业投资有限公司",
        },
        {
          label: "湖北省长江光电产业投资有限公司",
          value: "湖北省长江光电产业投资有限公司",
        },
        {
          label: "湖北省长江医疗产业投资有限公司",
          value: "湖北省长江医疗产业投资有限公司",
        },
      ],
      jobOptions: [
        { label: "总经理", value: "总经理" },
        { label: "副总经理", value: "副总经理" },
        { label: "总工程师", value: "总工程师" },
      ],
      jobList: [
        {
          id: 1,
          name: "总经理",
          secondCompany: "深圳万润科技股份有限公司",
          third: "",
          dept: "-",
          jobType: "集团中层正职",
          needNum: 1,
          education: "硕士",
          desc: "1.负责执行集团战略部署和公司党委、董事会决议；\n2.主持公司日常经营管理工作，组织实施公司年度经营计划，实现经营管理和发展目标；\n3.负责制订公司内部管理机构设置方案、管理制度，制订公司的具体规章；\n4.提请董事会聘任或者解聘公司副总裁、财务总监，决定聘任或者解聘除应由董事会决定聘任或者解聘以外的负责管理人员；\n5.履行公司章程和董事会授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过45周岁（1981年8月及以后出生）；\n2.具有硕士研究生及以上学历，新一代信息技术等相关专业；具有经济、管理类复合背景或从业经历者优先；\n3.具有10年以上新一代信息技术相关行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n5.特别优秀者条件可适当放宽。",
          location: "广东深圳",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 2,
          name: "总经理",
          secondCompany: "湖北长江北斗数字产业有限公司",
          third: "",
          dept: "",
          jobType: "集团中层正职",
          needNum: 1,
          education: "硕士",
          desc: "1.围绕长江产业集团关于北斗数字产业的战略发展规划，制定和实施公司发展战略和年度经营计划；\n2.主持公司日常经营管理工作，实现经营管理和发展目标；\n3.负责北斗及数字行业并购、产业项目、算力基建落地建设、词元产业链项目、人工智能项目等投资及运营管理；\n4.承担国家级、省级北斗数字领域、人工智能相关科技创新、应用创新的宏观管理工作；\n5.履行公司授予的其他职权及任务。",
          requirement:
            "1.年龄原则上不超过45周岁（1981年8月及以后出生）；\n2.具有硕士研究生及以上学历，遥感科学、计算机科学与技术、信息工程、电子信息等相关专业，具有经济、管理类复合背景或从业经历者优先；\n3.具有8年以上北斗、人工智能、大数据、软件、互联网、算力基建及运营等相关工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验，具有大型科技企业、行业头部企业背景、公司首发上市经验者优先；\n4.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n5.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 3,
          name: "总经理",
          secondCompany: "湖北省长江新动能私募基金管理有限公司",
          third: "",
          dept: "",
          jobType: "集团中层正职",
          needNum: 1,
          education: "硕士",
          desc: "1.负责执行集团战略部署和公司党支部决议；\n2.主持公司日常经营管理工作，组织实施公司年度经营计划，实现经营管理和发展目标；\n3.协助执行董事开展政策分析、行业研究、资本市场跟踪，做好并购投资、证券类资产市值管理和湖北ETF指数基金等业务，为公司决策提供依据和合理化建议；\n4.负责省上市公司高质量发展促进中心建设，构建“1+N”上市公司业务体系，打造湖北省资本市场基础性服务平台；\n5.履行公司章程授予的其他职权及任务。",
          requirement:
            "1.年龄原则上不超过45周岁（1981年8月及以后出生）；\n2.具有硕士研究生及以上学历，经济、管理、法律、工科等相关专业背景，需拥有基金从业资格；\n3.具有10年以上股权投资、投行或金融行业从业经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n5.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 4,
          name: "总工程师",
          secondCompany: "深圳万润科技股份有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.全面负责公司科技工作，根据国家政策与行业趋势，组织制订并实施科技创新战略与规划，推动科技成果转化及先进技术引进、消化、吸收与再创新；\n2.统筹研发机构及创新平台建设，建立健全科技项目管理体系，组织申报各级科技项目，审定技术方案并会签相关文件，推进产学研合作；\n3.主持制订技术管理、工艺标准、操作规程等规章制度，协助构建生产质量保证体系，主导解决生产与工艺环节的重大技术问题，推动全面质量管理与品牌建设；\n4.负责科技专家团队搭建及梯队人才培养，组织开展技术培训、考核与能力评定，对技术管理和重要技术岗位的定职、升职、奖惩和调动事项提出意见；\n5.编制并监督执行年度科技经费预算，审批技术项目开支；主管技术信息、档案、保密、计量、标准化、知识产权管理与科普、科技动向与相关外事工作，负责公司内外技术交流、合作、转让等工作；\n6.履行公司章程和董事会授予的其他职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，新一代信息技术相关专业，具有副高级以上职称；\n3.具有10年以上新一代信息技术相关行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.精通公司主业相关专业技术，了解公司所在行业专业领域的科技动态、技术水平、发展现状，熟悉相关领域的技术政策和法律法规，具有车灯行业工作经历优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "广东深圳",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 5,
          name: "副总经理",
          secondCompany: "湖北省长江新动能私募基金管理有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.协助总经理制定和落实公司年度经营计划、业务发展策略并组织落实，完成各项经营管理指标；\n2.负责集团所属证券类资产市值管理工作，负责建立集团证券类资产市值管理工作体系，制定证券类资产市值管理规划方案并推动实施；\n3.负责维护集团所属证券类资产市值和国有资产保值增值相关工作；\n4.负责组织湖北省上市公司高质量发展相关课题研究，跟踪研究湖北省上市公司发展情况，负责上市公司服务相关基金募投整体工作； \n5.履行公司章程授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，经济、管理、法律、工科等相关专业背景，拥有基金从业资格；\n3.具有8年以上证券公司或券商投资工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.熟悉国资监管、资本运作、金融业务等法律法规政策；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 6,
          name: "副总经理（化学工程与工艺方向）",
          secondCompany: "湖北长江产业现代化工有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.负责贯彻执行集团战略部署和公司党委、董事会决议；\n2.协助总经理统筹公司发展战略落地、生产经营工作，落实年度经营目标；\n3.负责推动优质化工产业项目投资落地及项目投后全流程管理工作；\n4.负责公司市场化运营体系与组织体系建设，完善市场化经营管理制度及工作流程，统筹推进业务团队建设和专业化能力建设；\n5.负责组织开展行业研究、项目研判，加强与各方面有效沟通合作，提升公司品牌形象；\n6.履行公司章程授予的其他职权及任务。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，应用化学、材料化学、化学工程与工艺、精细化工等相关专业；\n3.具有8年以上化工实体企业经营或产业投资工作经验，具有较强的化工产业链资源整合能力，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n5.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 7,
          name: "副总经理（资源循环利用方向）",
          secondCompany: "湖北省生态环保有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.协助统筹公司资源回收、循环利用板块整体经营管理工作，参与公司中长期发展战略、年度经营目标制定与落地实施；\n2.全面负责资源回收板块日常业务运营管理，统筹废旧物资回收网络搭建、区域合作、上下游供应链整合、大宗再生资源贸易等核心业务；\n3.结合国资监管及国企经营管理要求，牵头完善资源回收板块经营管理制度、标准化运营体系、内控风控体系，保障资源循环板块经营合法合规、平稳有序；\n4.负责与政府部门、相关单位的沟通协调，跟进行业政策、补贴政策、产业扶持项目申报等工作，整合行业技术、资金、渠道资源，赋能产业转型升级；\n5.完成董事长、总经理交办的其他工作任务。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，环境科学与工程类、材料类、机械类等相关专业，具有经济管理类复合专业背景者优先；\n3.具有5年以上再生资源回收、循环经济、环保产业、大宗物资贸易等相关行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.熟悉再生资源行业政策、市场行情、运营模式及行业上下游产业链资源，有成功的项目落地、市场开拓及业绩增长案例者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 8,
          name: "副总经理（矿产资源开发方向）",
          secondCompany: "湖北省长江新材有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.协助总经理制定并推动落实公司年度经营计划及业务发展策略，统筹分管领域资源，确保完成各项经营管理指标；\n2.围绕公司战略发展规划，参与公司日常经营管理工作，推动矿产资源开发板块与整体业务的协同发展，实现经营管理与战略目标；\n3.全面负责长江新材公司矿产板块相关企业的运营管理，统筹矿产资源开发、项目建设、成本管控、安全生产等核心工作，牵头解决运营中的重大风险与关键瓶颈问题；\n4.负责与政府部门、行业监管单位及相关合作单位的沟通协调工作，推动矿产资源开发相关审批、合规及合作事项顺利开展；\n5.牵头组织矿产资源项目的投资论证、尽职调查、交易谈判及投后管理，推动优质矿产资源获取与资产整合，提升公司资源储备与行业竞争力；\n6.履行公司章程授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，地质工程、采矿工程、选矿工程等相关专业；\n3.具有12年以上矿产资源、矿业工程、地质勘查或相关行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.主导或深度参与过矿产资源勘查、开发及运营管理全流程，有 2个以上矿产资源类投资项目成功经验者（如并购重组、矿权获取、开发建设、资本运作等）优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 9,
          name: "副总经理（智慧能源、绿色能源新材料方向）",
          secondCompany: "湖北省新能源有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.协助总经理制定公司年度经营计划及业务发展策略，并组织推进落实，确保完成各项经营管理指标；\n2.围绕长江产业集团和湖北新能源战略发展规划，协助日常经营管理工作，实现经营管理和发展目标；\n3.统筹新型储能、氢能、零碳园区、复合材料、绿色氢氨醇等项目的落地实施；\n4.负责与政府部门、相关单位的沟通联系及协调工作；\n5.履行公司章程授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，新能源科学与工程、电气工程、能源与动力工程等相关专业；有经济管理类复合专业背景者优先；\n3.具有8年以上新能源、智慧能源、绿色能源新材料等相关行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.具备上述相关行业并购重组、资本运作、大型项目管理等方面成功经验者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 10,
          name: "副总经理（产业园区方向）",
          secondCompany: "湖北长江产业载体投资开发有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.协助总经理制定和落实公司年度经营计划、业务发展策略并组织落实，完成各项经营管理指标；\n2.围绕长江投开战略发展规划，协助日常经营管理工作，实现经营管理和发展目标；\n3.具体负责长江投开公司相关实体企业的运营管理，全面统筹生产经营、项目建设、成本管控及安全生产等核心工作，牵头解决运营中的重大风险、关键瓶颈问题；\n4.负责与政府部门、相关单位的沟通联系及协调工作；\n5.履行公司章程授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，经济学、管理学、投资学、工商管理、法学等相关专业；\n3.具有8年以上产业园区运营、投资开发、工程建设相关行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.具备上述相关行业并购重组、资本运作、大型项目管理等方面成功经验者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 11,
          name: "副总经理（人力资源服务方向）",
          secondCompany: "湖北省人才发展集团有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.协助总经理制定和落实公司年度经营计划、业务发展策略并组织落实，完成各项经营管理指标；\n2.围绕省人才集团战略发展规划，协助日常经营管理工作，实现经营管理和发展目标；\n3.围绕人才招引服务、考试测评服务、人才培训与咨询、人力资源外包等核心业务方面，统筹落实各项业务工作；\n4.负责与党委、政府部门、相关单位的沟通联系及协调工作；\n5.履行公司章程授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，人力资源管理、工商管理、公共管理、行政管理、社会学等相关专业；                                                                         \n3.具有8年以上人力资源服务相关工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.具备上述相关行业并购重组、资本运作、大型项目管理等方面成功经验者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 12,
          name: "副总经理（人工智能、时空信息方向）",
          secondCompany: "湖北长江北斗数字产业有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 2,
          education: "硕士",
          desc: "1.负责制定和实施北斗数字公司发展战略和年度经营计划；\n2.协助日常经营管理工作，实现经营管理和发展目标；\n3.具体负责北斗及数字行业产业项目、算力基建、词元产业链、AI落地项目的运营管理；\n4.履行公司授予的其他职权和任务。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，遥感科学、计算机科学与技术、信息工程、电子信息等相关专业，有经济管理类复合专业背景者优先；\n3.具有5年以上北斗时空信息、人工智能、大数据、软件、互联网、数字基建等行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n5.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 13,
          name: "副总经理",
          secondCompany: "湖北长江产融资本投资有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.协助总经理制定和落实公司年度经营计划及风控合规、资产管理专项策略，完成分管领域的各项管理指标；\n2.围绕长江产融资本战略发展规划，协助负责公司债权类业务的风险防控体系建设和资产管理工作，实现资产安全与合规经营目标；\n3.具体负责长江产融资本相关项目的运营管理，涵盖风险防控、合规管理、资产管理、团队建设及日常运营等核心环节；\n4.负责与政府部门、相关单位的沟通联系及协调工作；\n5.履行公司章程授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，经济学、管理学、法学、理学等相关专业，海外高校理学硕士（MSc）学位视同上述相关专业；\n3.具有8年及以上银行/租赁/担保等相关工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.具备债权类资产风险管控、合规体系搭建、不良资产处置及大型风控项目统筹经验者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 14,
          name: "副总经理（并购投资方向）",
          secondCompany: "湖北长江汽车产业投资有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1、负责组织贯彻落实集团汽车产业重要工作部署，具体负责集团汽车与高端装备产业领域的投资管理、资本运营工作，推动汽车板块高质量发展；\n2、统筹发起设立汽车产业链基金并负责基金项目投资，与汽车板块实体企业联动，以基金服务实体企业业务拓展；\n3、负责汽车产业链并购工作，围绕集团汽车板块强链、延链、补链，储备并购项目、推动并购项目实施；\n4、负责与政府部门、相关单位的沟通联系及协调工作，统筹争取所在行业外部政策、资金、资源支持；\n5、履行公司章程和董事会授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，经济学、管理学、法学、理工科等相关专业，持有注册会计师（CPA）、法律职业资格、特许金融分析师（CFA）等执业资格证书者优先；\n3.具有8年以上券商、财务、法律、私募股权基金相关工作经验，其中不少于2年私募股权基金工作经验，担任过基金管理公司高管者优先；\n4.具备汽车与高端装备领域投资银行业务经验、项目投资IPO成功经验者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 15,
          name: "副总经理（整车方向）",
          secondCompany: "湖北长江汽车产业投资有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.负责组织贯彻落实集团汽车产业重要工作部署，承接省委、省政府、上级主管部门交办的整车领域专项重点任务；\n2.研究汽车整车行业政策、技术迭代、市场趋势，牵头编制集团整车业务中长期发展规划和推进方案，并推进落实；\n3.负责组织谋划长江汽车公司项目并购，组织完成公司经营目标；\n4.负责集团整车板块新建、技改、扩产、合资建厂等投资项目把控把关和评审；\n5.统筹促进集团汽车产业成员单位整车研发迭代、三电技术落地、整车平台自主化攻关，推进整车产品出海、海外建厂、海外供应链布局等国际化业务；\n6.负责统筹推动集团汽车产业成员单位整车研发、生产制造、营销、售后体系协同运营，盘活内部产能与渠道资源；\n7.负责与政府部门、相关单位的沟通联系及协调工作，统筹争取所在行业外部政策、资金、资源支持；\n8.履行公司章程和董事会授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，车辆工程、机械设计、新能源汽车工程、智能制造、电子信息、信息与通信工程等相关专业，具有经济金融与理工科复合专业背景者优先；\n3.具有8年以上汽车行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.具备企业并购重组、整车项目落地、整车产线运营等方面成功经验者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 16,
          name: "副总经理（汽车零部件方向）",
          secondCompany: "湖北长江汽车产业投资有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 1,
          education: "硕士",
          desc: "1.负责组织贯彻落实集团汽车产业重要工作部署，承接省委、省政府、上级主管部门交办的汽车零部件领域专项重点任务；\n2.研究汽车核心零部件、汽车电子、底盘系统、动力电池配套、汽车轻量化等细分领域政策、技术路线、供需趋势，编制集团零部件板块产业发展规划，并推进落地；\n3.负责组织谋划长江汽车公司项目并购，组织完成公司经营目标；\n4.负责集团汽车产业成员单位扩产、新材料产线、零部件国产化替代、零部件配套等投资项目把控把关和评审；\n5.统筹促进集团汽车产业成员单位零部件技术攻关、国产替代研发、新工艺落地，推进核心零部件产品配套国内外整车厂、零部件产品出口国际化布局；\n6.负责统筹推动集团汽车产业成员单位业务协同，推动原材料集采、联合研发、产能共享，打通上下游降本增效协同体系；\n7.负责与政府部门、相关单位的沟通联系及协调工作，统筹争取所在行业外部政策、资金、资源支持；\n8.履行公司章程和董事会授予的其他职能职责。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，车辆工程、汽车零部件、机械设计、新能源汽车工程、智能制造、电子信息、信息与通信工程等相关专业，具有经济金融与理工科复合专业背景者优先；\n3.具有8年以上汽车行业工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.具备企业并购、汽车零部件研发、生产、配套全链条管理等方面成功经验者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 17,
          name: "副总经理",
          secondCompany: "湖北省长江光电产业投资有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 2,
          education: "硕士",
          desc: "1.协助总经理统筹编制、拆解并全程督导公司年度经营计划与中长期发展战略，对分管领域经营业绩、效益指标、管理目标负责，确保各项指标全面达成；\n2.深度承接长江产业集团整体战略部署，全面分管公司日常经营、组织架构优化、人才梯队建设、内控风控及管理体系搭建，推动企业战略落地与高质量发展；\n3.负责长江光电公司相关实体企业运营管理、市场开拓、产业布局及内外资源整合等工作；\n4.牵头搭建并维护政企、行业协会、产业链上下游、投融资机构等资源网络，统筹开展重大商务谈判、对外合作、品牌对接及专项协调工作；\n5.严格执行公司章程，完成集团交办的其他重大经营管理及专项任务。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.硕士研究生及以上学历，电子信息、集成电路科学与工程、信息与通信工程、人工智能、大数据等相关专业，具有副高级及以上专业技术职称、高级职业资格，或持有注册会计师（CPA）、法律职业资格、特许金融分析师（CFA）等执业资格证书者优先；\n3.具有8年以上半导体、光电子、光通信、人工智能、大数据、软件、互联网等领域工作经验，熟悉现代企业治理、内控体系、经营风控及相关行业政策法规，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.在集成电路、光通信、人工智能等领域具备深厚行业积淀、优质行业资源及较高行业影响力，拥有产业并购重组、投融资、资本运作、重大项目全流程操盘等成功经验者优先；\n5.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n6.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
        {
          id: 18,
          name: "副总经理",
          secondCompany: "湖北省长江医疗产业投资有限公司",
          third: "",
          dept: "",
          jobType: "集团中层副职",
          needNum: 2,
          education: "硕士",
          desc: "1.协助总经理制定和落实公司年度经营计划、业务发展策略并组织落实，完成各项经营管理指标；\n2.负责合理配置、协调公司内外资源，把控投资项目的立项管理、尽职调查、行业研究、交易方案设计、商务谈判、项目交割、投后管理等工作；\n3.负责制定公司的运营管理体系，建立管控权限、职责和关键控制点以及定期调整机制，保障项目运营；\n4.负责与政府部门、相关单位的沟通联系及协调工作；\n5.履行公司章程授予的其他职能职责，完成公司领导交办的其他工作。",
          requirement:
            "1.年龄原则上不超过40周岁（1986年8月及以后出生）；\n2.具有硕士研究生及以上学历，生物、药学、医学等生物医药相关专业。具有经济金融与理工科复合专业背景者优先；\n3.具有8年及以上生物医药行业投融资或实体运营相关工作经验，其中不少于同类大中型机构2年同职级或5年以上下一职级工作经验；\n4.熟悉生物医药产业链，精准把握产业政策、行业格局与发展趋势，对生物医药产业研发、审批、生产、销售、BD出海等行业方向有深入理解；\n5.能牵头完成生物医药领域股权投资或产业运营工作；在以下三个方向：（1）创新药、（2）脑机接口等创新医疗器械、（3）生物制造及合成生物学等领域具备重大项目股权投资、并购重组、资本运作、运营管理等方面丰富经验者优先；熟悉高校、科研院所及医院成果转化者优先；\n6.近3年年度考核结果为胜任（称职）及以上（需提供近3年工作业绩证明材料）；\n7.特别优秀者条件可适当放宽。",
          location: "湖北武汉",
          salary: "",
          url: "https://ks.jobhb.com/wsbm/sys-list-hb?fcode=ctzp2026",
        },
      ],
    };
  },
  computed: {
    filteredJobs() {
      return this.jobList.filter((job) => {
        let isOk = true;
        if (this.selectedSecond)
          isOk = isOk && job.secondCompany === this.selectedSecond;
        if (this.name) {
          if (this.name === "总经理") {
            // 精准匹配，只能完全等于总经理
            isOk = isOk && job.name === this.name;
          } else {
            // 模糊匹配，只要包含关键词就符合
            isOk = isOk && job.name.includes(this.name);
          }
        }
        return isOk;
      });
    },
  },
  methods: {
    goLink(url) {
      if (url && url !== "#") window.open(url, "_blank");
    },
    toggleDetail(id) {
      const idx = this.openIds.indexOf(id);
      if (idx > -1) this.openIds.splice(idx, 1);
      else this.openIds.push(id);
    },
  },
};
</script>

<style scoped lang="less">
.job-page {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 15px;
  box-sizing: border-box;
}
.select-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}
.select-box {
  flex-shrink: 0;
  /deep/ .el-select {
    width: 100%;
    min-width: 200px;
    max-width: 260px;
  }
  /deep/ .el-input__inner {
    height: 44px;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    font-size: 15px;
    transition: all 0.2s;
  }
  /deep/ .el-select:hover .el-input__inner {
    border-color: #006699;
  }
  /deep/ .el-select:focus .el-input__inner {
    border-color: #006699;
    box-shadow: 0 0 0 2px rgba(0, 86, 179, 0.1);
  }
}
.job-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
}
.job-item {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 86, 179, 0.06);
  border-left: 4px solid #006699;
  transition: transform 0.2s;
  cursor: pointer;
}
.job-item:hover {
  transform: translateY(-3px);
}
/* 头部：左右固定布局，不换行 */
.job-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 12px;
}
.job-left {
  flex: 1;
  min-width: 0;
}
.job-name {
  font-size: 18px;
  font-weight: bold;
  color: #006699;
  margin-bottom: 8px;
}
.job-company {
  font-size: 14px;
  color: #333;
}
.apply-btn {
  flex-shrink: 0;
  /deep/ .el-button {
    background-color: #006699;
    border-color: #006699;
    border-radius: 6px;
  }
  /deep/ .el-button:hover {
    background-color: #005580;
    border-color: #005580;
  }
}
/deep/ .el-button [class*="el-icon-"] + span {
  margin-left: 0;
}
.job-info {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 12px 0;
}
.info-item {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.desc-block {
  margin-top: 8px;
}
.desc-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
}
.arrow {
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid #666;
  transition: transform 0.2s;
}
.arrow.open {
  transform: rotate(180deg);
}
.desc-content {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  white-space: pre-line;
  margin-top: 6px;
}
.sub-title {
  font-weight: bold;
}
.empty {
  grid-column: 1 / -1;
  text-align: center;
  color: #999;
  padding: 60px 0;
  font-size: 15px;
}

/* 移动端适配：头部布局保持左右结构，不换行 */
@media (max-width: 768px) {
  .job-page {
    padding: 15px 12px;
  }
  .select-row {
    flex-direction: column;
    align-items: stretch;
  }
  .select-box /deep/ .el-select {
    max-width: 100%;
  }
  .job-list {
    grid-template-columns: 1fr;
  }
  .job-item {
    padding: 18px;
  }
  .job-info {
    gap: 10px;
  }
}
</style>